export default {
  dictionary: [],
  groups: [],
  count: 0,
  pagination: {
    page: 1,
    rowPerPage: 20,
  },
};
